import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { getAuthRouteDecision } from '@/lib/auth-session'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomePage.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/RegisterPage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/mfa-challenge',
      name: 'mfa-challenge',
      component: () => import('@/pages/MfaChallengePage.vue'),
      meta: { guestOnly: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/pages/DashboardPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/leagues',
      name: 'leagues',
      component: () => import('@/pages/LeagueSetupPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/players',
      name: 'players',
      component: () => import('@/pages/PlayerPoolPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/drafts',
      name: 'drafts',
      component: () => import('@/pages/DraftConfigurationPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/draft-board',
      name: 'draft-board',
      component: () => import('@/pages/LiveDraftBoardPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/strategy',
      name: 'strategy',
      component: () => import('@/pages/MyStrategyPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/pages/SettingsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/auth-unavailable',
      name: 'auth-unavailable',
      component: () => import('@/pages/AuthUnavailablePage.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/pages/NotFoundPage.vue')
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth check to complete if not yet done
  if (!authStore.initialized) {
    await authStore.checkAuth()
  }

  const decision = getAuthRouteDecision(
    { requiresAuth: Boolean(to.meta.requiresAuth), guestOnly: Boolean(to.meta.guestOnly) },
    authStore.authStatus
  )

  if (decision === 'dashboard') return next({ name: 'dashboard' })
  if (decision === 'login') return next({ name: 'login', query: { redirect: to.fullPath } })
  if (decision === 'auth-unavailable') {
    return next({ name: 'auth-unavailable', query: { redirect: to.fullPath } })
  }

  next()
})

export default router
